import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionHeading, fadeUp, scrollToId } from "@/components/landing/shared";
import { useSiteContent } from "@/context/ContentContext";

export default function InvestmentSection() {
  const { investment } = useSiteContent();
  const tiers = investment.tiers || [];
  return (
    <section
      id="investimento"
      className="relative scroll-mt-20 border-t border-black/[0.08] py-16 md:py-24 lg:py-28"
    >
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow={investment.eyebrow}
          title={investment.title}
          intro={investment.intro}
        />

        <div className="mt-12 grid grid-cols-1 gap-5 lg:grid-cols-3 lg:gap-6">
          {tiers.map((t, i) => (
            <motion.div
              key={`${t.title}-${i}`}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              variants={fadeUp}
              custom={i}
              className={`flex flex-col rounded-2xl border p-7 ${
                t.highlighted
                  ? "border-emerald-400/30 bg-emerald-600/[0.05]"
                  : "border-black/10 bg-white"
              }`}
            >
              <h3 className="text-base font-semibold text-[color:var(--text-primary)]">
                {t.title}
              </h3>
              <p className="mt-4 font-display text-2xl font-semibold tracking-[-0.02em] text-emerald-700 tabnum">
                {t.price}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-secondary">
                {t.body}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          variants={fadeUp}
          className="mt-8 flex flex-col items-start justify-between gap-6 rounded-2xl border border-black/10 bg-black/[0.02] px-6 py-6 md:flex-row md:items-center"
        >
          <p className="max-w-2xl text-sm leading-relaxed text-secondary">
            {investment.note}
          </p>
          <Button
            data-testid="investment-cta-button"
            onClick={() => scrollToId("#contatto")}
            className="h-12 shrink-0 rounded-xl bg-emerald-700 px-6 text-[15px] font-medium text-white transition-colors duration-200 hover:bg-emerald-600"
          >
            {investment.cta}
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
